//People api calls

//Get all people
const getAllPeople = async (language_code = "en") => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getAllPeople/${language_code}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => {
      //console.log("getAllPeople(): ", json);
      return json;
    })
    .catch((error) => {
      console.log(error);
      return undefined;
    });
};

export { getAllPeople };
